import { CATEGORY_LABEL, type NoticeCategory } from './noticeApi';

const STYLE: Record<NoticeCategory, string> = {
  POLICY: 'bg-red-500/10 text-red-300 ring-red-500/30',
  SERVICE: 'bg-gray-700/40 text-gray-200 ring-gray-600/50',
  MAINTENANCE: 'bg-amber-500/10 text-amber-300 ring-amber-500/30',
};

export function CategoryBadge({ category }: { category: NoticeCategory }) {
  return (
    <span className={`inline-block w-fit shrink-0 rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${STYLE[category]}`}>
      {CATEGORY_LABEL[category]}
    </span>
  );
}
